import { render, staticRenderFns } from "./PushedMessageList.vue?vue&type=template&id=7728b7b4&scoped=true&"
import script from "./PushedMessageList.vue?vue&type=script&lang=js&"
export * from "./PushedMessageList.vue?vue&type=script&lang=js&"
import style0 from "./PushedMessageList.vue?vue&type=style&index=0&id=7728b7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7728b7b4",
  null
  
)

export default component.exports